import { useTranslation } from 'react-i18next'
import FormDialog from '../Common/Dialog/FormDialog'

interface LoanListFiltersDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}

const LoanListFiltersDialog = ({ open, onClose, onSubmit }: LoanListFiltersDialogProps) => {
  const { t } = useTranslation()

  return (
    <FormDialog title={t('loan.fundedProducts')} onClose={onClose} onConfirm={onSubmit} open={open}>
      <div>Euh.... pas de filtre?</div>
    </FormDialog>
  )
}

export default LoanListFiltersDialog
